import api from "@/config/http-client-gateway";
import { showErrorToast } from '@/kernel/alerts';

export const getMessages = async (params) => {
  try {
    const response = await api.doGet('/get-all-contact', {params});
    return response?.data;
  } catch (error) {
    console.log('Error fetching messages:', error);
    showErrorToast('Error trayendo los mensajes de contacto');
  }
}

export const changeStatusMessage = async (data) => {
  try {
    const response = await api.doPut('/change-status-contact', data);
    return response?.data;
  } catch (error) {
    console.log('Error changing message status:', error);
    showErrorToast('Error cambiando el estado del mensaje');
  }
}

export const sendMessageBack = async (data) => {
  try {
    const response = await api.doPost('/sent-message-back', data);
    return response?.data;
  } catch (error) {
    console.log('Error sending message back:', error);
    showErrorToast('Error enviando el mensaje de respuesta');
  }
}